/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CartModificationList,
  ErrorList,
  Order,
  OrderComment,
  OrderHistoryList,
  ReplenishmentOrder,
  ScheduleReplenishmentForm,
} from '../models';
import {
    CartModificationListFromJSON,
    CartModificationListToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
    OrderFromJSON,
    OrderToJSON,
    OrderCommentFromJSON,
    OrderCommentToJSON,
    OrderHistoryListFromJSON,
    OrderHistoryListToJSON,
    ReplenishmentOrderFromJSON,
    ReplenishmentOrderToJSON,
    ScheduleReplenishmentFormFromJSON,
    ScheduleReplenishmentFormToJSON,
} from '../models';

export interface CreateCartFromOrderRequest {
    baseSiteId: string;
    orderCode: string;
    userId: string;
    fields?: CreateCartFromOrderFieldsEnum;
    sapCommerceCloudCustomerId?: string;
}

export interface CreateReplenishmentOrderRequest {
    baseSiteId: string;
    cartId: string;
    termsChecked: boolean;
    userId: string;
    scheduleReplenishmentForm: ScheduleReplenishmentForm;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetBranchOrderRequest {
    baseSiteId: string;
    code: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserBranchOrderHistoryRequest {
    baseSiteId: string;
    userId: string;
    currentPage?: number;
    fields?: string;
    filters?: string;
    pageSize?: number;
    sort?: string;
    statuses?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface PlaceOrgOrderRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
    orderComment?: OrderComment;
}

/**
 * B2BOrdersApi - interface
 * 
 * @export
 * @interface B2BOrdersApiInterface
 */
export interface B2BOrdersApiInterface {
    /**
     * Returns a list of modification applied to the new cart compared to original. e.g lower quantity was added
     * @summary Creates a cart from a previous order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} orderCode Order code.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {'BASIC' | 'DEFAULT' | 'FULL'} [fields] Response configuration. This is the list of fields that should be returned in the response body.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BOrdersApiInterface
     */
    createCartFromOrderRaw(requestParameters: CreateCartFromOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>>;

    /**
     * Returns a list of modification applied to the new cart compared to original. e.g lower quantity was added
     * Creates a cart from a previous order.
     */
    createCartFromOrder(requestParameters: CreateCartFromOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList>;

    /**
     * Creates and schedules replenishment orders. By default, the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * @summary Creates replenishment orders.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {boolean} termsChecked Whether terms were accepted or not.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {ScheduleReplenishmentForm} scheduleReplenishmentForm 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BOrdersApiInterface
     */
    createReplenishmentOrderRaw(requestParameters: CreateReplenishmentOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReplenishmentOrder>>;

    /**
     * Creates and schedules replenishment orders. By default, the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * Creates replenishment orders.
     */
    createReplenishmentOrder(requestParameters: CreateReplenishmentOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReplenishmentOrder>;

    /**
     * Retrieves the details of the order using a unique order code in the customer\'s default organization branch. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * @summary Retrieves the order from the customer\'s organization branch.
     * @param {string} baseSiteId Base site identifier
     * @param {string} code Order code.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BOrdersApiInterface
     */
    getBranchOrderRaw(requestParameters: GetBranchOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * Retrieves the details of the order using a unique order code in the customer\'s default organization branch. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order from the customer\'s organization branch.
     */
    getBranchOrder(requestParameters: GetBranchOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

    /**
     * Retrieves the order history of a default organization branch for a base site. The response may display the results across multiple pages, when applicable.
     * @summary Retrieves the order history for the customer\'s organization branch.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] Current result page. Default value is 0.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [filters] Serialized filters applied to the query in the following format: ::facetKey1:facetValue1:facetKey2:facetValue2. Correct values for facetKey are \&#39;user\&#39; and \&#39;unit\&#39;.
     * @param {number} [pageSize] The number of results returned per page.
     * @param {string} [sort] Sorting method applied to the return results.
     * @param {string} [statuses] Filters only certain order statuses. For example, statuses&#x3D;CANCELLED,CHECKED_VALID would only return orders with status CANCELLED or CHECKED_VALID.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BOrdersApiInterface
     */
    getUserBranchOrderHistoryRaw(requestParameters: GetUserBranchOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderHistoryList>>;

    /**
     * Retrieves the order history of a default organization branch for a base site. The response may display the results across multiple pages, when applicable.
     * Retrieves the order history for the customer\'s organization branch.
     */
    getUserBranchOrderHistory(requestParameters: GetUserBranchOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderHistoryList>;

    /**
     * Creates a B2B order. By default the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * @summary Creates a B2B order.
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {OrderComment} [orderComment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BOrdersApiInterface
     */
    placeOrgOrderRaw(requestParameters: PlaceOrgOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>>;

    /**
     * Creates a B2B order. By default the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * Creates a B2B order.
     */
    placeOrgOrder(requestParameters: PlaceOrgOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order>;

}

/**
 * 
 */
export class B2BOrdersApi extends runtime.BaseAPI implements B2BOrdersApiInterface {

    /**
     * Returns a list of modification applied to the new cart compared to original. e.g lower quantity was added
     * Creates a cart from a previous order.
     */
    async createCartFromOrderRaw(requestParameters: CreateCartFromOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createCartFromOrder.');
        }

        if (requestParameters.orderCode === null || requestParameters.orderCode === undefined) {
            throw new runtime.RequiredError('orderCode','Required parameter requestParameters.orderCode was null or undefined when calling createCartFromOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling createCartFromOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.orderCode !== undefined) {
            queryParameters['orderCode'] = requestParameters.orderCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/cartFromOrder`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationListFromJSON(jsonValue));
    }

    /**
     * Returns a list of modification applied to the new cart compared to original. e.g lower quantity was added
     * Creates a cart from a previous order.
     */
    async createCartFromOrder(requestParameters: CreateCartFromOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList> {
        const response = await this.createCartFromOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates and schedules replenishment orders. By default, the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * Creates replenishment orders.
     */
    async createReplenishmentOrderRaw(requestParameters: CreateReplenishmentOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReplenishmentOrder>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createReplenishmentOrder.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling createReplenishmentOrder.');
        }

        if (requestParameters.termsChecked === null || requestParameters.termsChecked === undefined) {
            throw new runtime.RequiredError('termsChecked','Required parameter requestParameters.termsChecked was null or undefined when calling createReplenishmentOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling createReplenishmentOrder.');
        }

        if (requestParameters.scheduleReplenishmentForm === null || requestParameters.scheduleReplenishmentForm === undefined) {
            throw new runtime.RequiredError('scheduleReplenishmentForm','Required parameter requestParameters.scheduleReplenishmentForm was null or undefined when calling createReplenishmentOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.cartId !== undefined) {
            queryParameters['cartId'] = requestParameters.cartId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.termsChecked !== undefined) {
            queryParameters['termsChecked'] = requestParameters.termsChecked;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/replenishmentOrders`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleReplenishmentFormToJSON(requestParameters.scheduleReplenishmentForm),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReplenishmentOrderFromJSON(jsonValue));
    }

    /**
     * Creates and schedules replenishment orders. By default, the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * Creates replenishment orders.
     */
    async createReplenishmentOrder(requestParameters: CreateReplenishmentOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReplenishmentOrder> {
        const response = await this.createReplenishmentOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the details of the order using a unique order code in the customer\'s default organization branch. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order from the customer\'s organization branch.
     */
    async getBranchOrderRaw(requestParameters: GetBranchOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getBranchOrder.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getBranchOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getBranchOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/orgUnits/orders/{code}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Retrieves the details of the order using a unique order code in the customer\'s default organization branch. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves the order from the customer\'s organization branch.
     */
    async getBranchOrder(requestParameters: GetBranchOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.getBranchOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the order history of a default organization branch for a base site. The response may display the results across multiple pages, when applicable.
     * Retrieves the order history for the customer\'s organization branch.
     */
    async getUserBranchOrderHistoryRaw(requestParameters: GetUserBranchOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderHistoryList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserBranchOrderHistory.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserBranchOrderHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.statuses !== undefined) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/orgUnits/orders`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderHistoryListFromJSON(jsonValue));
    }

    /**
     * Retrieves the order history of a default organization branch for a base site. The response may display the results across multiple pages, when applicable.
     * Retrieves the order history for the customer\'s organization branch.
     */
    async getUserBranchOrderHistory(requestParameters: GetUserBranchOrderHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderHistoryList> {
        const response = await this.getUserBranchOrderHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a B2B order. By default the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * Creates a B2B order.
     */
    async placeOrgOrderRaw(requestParameters: PlaceOrgOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling placeOrgOrder.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling placeOrgOrder.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling placeOrgOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.cartId !== undefined) {
            queryParameters['cartId'] = requestParameters.cartId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/orders`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCommentToJSON(requestParameters.orderComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Creates a B2B order. By default the payment type is ACCOUNT. Set payment type to CARD if placing an order using credit card.
     * Creates a B2B order.
     */
    async placeOrgOrder(requestParameters: PlaceOrgOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.placeOrgOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateCartFromOrderFieldsEnum = {
    Basic: 'BASIC',
    Default: 'DEFAULT',
    Full: 'FULL'
} as const;
export type CreateCartFromOrderFieldsEnum = typeof CreateCartFromOrderFieldsEnum[keyof typeof CreateCartFromOrderFieldsEnum];
